export const TAKE_ACTION_DRAFT_PREVIEW_KEY = "civix_campaign_take_action_draft_preview";

/** Draft previews expire after 30 minutes. */
const PREVIEW_TTL_MS = 30 * 60 * 1000;

export function saveTakeActionDraftPreview({ campaign, displayTargets = [] }) {
  if (typeof window === "undefined") return false;
  try {
    // localStorage (not sessionStorage) so data is available in a new tab from window.open.
    window.localStorage.setItem(
      TAKE_ACTION_DRAFT_PREVIEW_KEY,
      JSON.stringify({
        campaign,
        displayTargets,
        savedAt: Date.now(),
      })
    );
    return true;
  } catch {
    return false;
  }
}

export function loadTakeActionDraftPreview() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(TAKE_ACTION_DRAFT_PREVIEW_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.campaign) return null;
    if (parsed.savedAt && Date.now() - parsed.savedAt > PREVIEW_TTL_MS) {
      window.localStorage.removeItem(TAKE_ACTION_DRAFT_PREVIEW_KEY);
      return null;
    }
    return {
      campaign: parsed.campaign,
      displayTargets: Array.isArray(parsed.displayTargets) ? parsed.displayTargets : [],
    };
  } catch {
    return null;
  }
}

export function clearTakeActionDraftPreview() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(TAKE_ACTION_DRAFT_PREVIEW_KEY);
  } catch {
    // ignore
  }
}
